$(document).ready(function () {
  // console.log("slider");
  $('.publisher-slider').slick({
    
    dots: false,
    infinite: true,
    arrows:false,
    autoplay:true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          infinite: true,
          dots: false
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
    {
        breakpoint: 370,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  });
  
  $('.testimonial-slider').slick({
    dots: false,
    infinite: true,
    arrows:true,
    autoplay:true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  });
  
  $('.switch-target').click(function (){
  $('html, body').animate({
    scrollTop: $("#testimonial-section").offset().top
  }, 1000)
  })
  
  $("#view-video").fancybox({
     openEffect	: 'elastic',
     closeEffect	: 'elastic',
     helpers : {
     title : {
     type : 'inside'
          }
       }
  });

  $(window).on('scroll', function (){   
    var sticky = $('.top-head'),
    scroll = $(window).scrollTop();
    if (scroll >= 100) sticky.addClass('fixed');
    else sticky.removeClass('fixed');
  });

  $( document ).ready(function() {
    $('.playlist-slider>.row').slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      autoplay: true,
      arrows:false,
      dots:false,
      autoplaySpeed: 4000,
      responsive: [
        {
        breakpoint: 1199,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
          }
        },
        {
        breakpoint: 991,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          }
        },
        {
        breakpoint: 767,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          }
        },
        {
        breakpoint: 440,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          }
        }
      ]
    });
  });
  });
  